import React from "react";
import LGWashingPageTemplate from "./LGWashingPageTemplate";

const relatedLinks = [
  { to: "/lg-appliance-service-bangalore", label: "LG Appliance Service" },
  { to: "/lg-washing-machine-service-bangalore", label: "LG Washing Machine Service" },
  { to: "/lg-washing-machine-not-spinning", label: "LG Washing Machine Not Spinning" },
  { to: "/lg-front-load-washing-machine-service-bangalore", label: "LG Front Load Service" },
  { to: "/lg-top-load-washing-machine-service-bangalore", label: "LG Top Load Service" },
];

const LGWashingMachineRepair = () => {
  return (
    <LGWashingPageTemplate
      title="LG Washing Machine Repair in Bangalore"
      description="Expert LG washing machine repair in Bangalore for motor faults, PCB problems, leaks, and spin issues with doorstep technician service."
      keywords="lg washing machine repair bangalore, lg washer technician bangalore, lg machine service"
      path="/lg-washing-machine-repair-bangalore"
      bannerTitle="LG Washing Machine Repair in Bangalore"
      intro={<>If your <span style={{ fontWeight: 'bold' }}>LG washing machine repair in Bangalore</span> is needed for not washing properly, not draining, or has stopped working, our team can inspect and fix the issue at home. We handle mechanical and electrical faults for major LG washing machine models.</>}
      highlights={[
        "Motor, pump, and drainage system repair",
        "PCB, timer, and control board inspection",
        "Door lock, sensor, and inlet valve repair",
        "Preventive maintenance and service visits",
      ]}
      issues={[
        "Machine not working",
        "Water not draining",
        "Power supply or board faults",
        "Drum movement and spin issues",
      ]}
      relatedLinks={relatedLinks}
    />
  );
};

export default LGWashingMachineRepair;
